import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface PrintKmModalProps {
  open: boolean
  onClose: () => void
  onPrint: (sequenceNumbers: number[]) => void
  isLoading?: boolean
}

function parseSequenceInput(raw: string): number[] {
  const parts = raw
    .split(/[,;\s]+/)
    .map((s) => s.trim())
    .filter(Boolean)
  const nums = new Set<number>()
  for (const part of parts) {
    if (part.includes('-')) {
      const [a, b] = part.split('-').map((x) => parseInt(x.trim(), 10))
      if (!Number.isFinite(a) || !Number.isFinite(b)) continue
      const lo = Math.min(a, b)
      const hi = Math.max(a, b)
      for (let i = lo; i <= hi; i++) nums.add(i)
    } else {
      const n = parseInt(part, 10)
      if (Number.isFinite(n) && n > 0) nums.add(n)
    }
  }
  return [...nums].sort((a, b) => a - b)
}

export function PrintKmModal({ open, onClose, onPrint, isLoading }: PrintKmModalProps) {
  const [input, setInput] = useState('')

  if (!open) return null

  const handleSubmit = () => {
    const nums = parseSequenceInput(input)
    if (!nums.length) return
    onPrint(nums)
    setInput('')
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h3 className="text-lg font-semibold mb-2">Печать КМ</h3>
        <p className="text-sm text-gray-500 mb-4">
          Номера через запятую или диапазон, например: 1, 5, 10-15
        </p>
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="1, 2, 3..."
          autoFocus
        />
        <div className="flex justify-end gap-2 mt-6">
          <Button variant="ghost" onClick={onClose}>
            Отмена
          </Button>
          <Button onClick={handleSubmit} isLoading={isLoading}>
            Печать
          </Button>
        </div>
      </div>
    </div>
  )
}
